import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';
import { isProd } from 'gatsby-theme-agria/src/client';

export const ScriptsBefore = () => {
  /* eslint-disable prefer-destructuring -- Gatsby env can't be destructured */
  const COOKIES_CODE = process.env.GATSBY_COOKIES_CODE;
  const LOAD_SURFLY = process.env.GATSBY_LOAD_SURFLY === 'true';
  const LOAD_LIVE_CHAT = process.env.GATSBY_LOAD_LIVE_CHAT;

  return (
    <>
      {/* // OneTrust Cookies Consent Notice */}
      {COOKIES_CODE !== undefined && COOKIES_CODE !== '' && (
        <>
          <Script
            strategy={ScriptStrategy.postHydrate}
            type="text/javascript"
            src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
            data-domain-script={`${COOKIES_CODE}${!isProd ? '-test' : ''}`}
          />
          <Script
            strategy={ScriptStrategy.postHydrate}
            type="text/javascript"
            dangerouslySetInnerHTML={{ __html: 'function OptanonWrapper() {}' }}
          />
        </>
      )}

      {/* GTM */}
      <Script strategy={ScriptStrategy.postHydrate}>
        {`!function(){"use strict";function l(e){for(var t=e,r=0,n=document.cookie.split(";");r<n.length;r++){var o=n[r].split("=");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r="script",n="dataLayer",o="https://stss.kcinsurance.co.uk",a="https://load.stss.kcinsurance.co.uk",i="8pzhkdujhystf",c="f3u4yldi=DxBOPjwnWC8gOitBLEwDWVRaQl8MBEgPBR0dCh0YFAoFEV0aB0QADw%3D%3D",g="cookie",v="_ga",E="",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp("Version/([0-9._]+)(.*Mobile)?.*Safari.*").exec(m)))&&16.4<=parseFloat(m[1]),f="stapeUserId"===g,I=d&&!f?function(e,t,r){void 0===t&&(t="");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn("invalid uid source",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"}),t.getElementsByTagName(r)[0]),v=I?"&bi="+encodeURIComponent(I):"",E=t.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,"kp$1"):"kp"+i),!d&&a?a:o);E.async=!0,E.src=f+"/"+i+".js?"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();`}
      </Script>
      <noscript>
        <iframe
          src="https://load.stss.kcinsurance.co.uk/ns.html?id=GTM-KFNX8D"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
          title="gtm-frame"
        />
      </noscript>
    
     {/* Livechat (CXone) Integration */}
      {LOAD_LIVE_CHAT && (
        <Script
          strategy={ScriptStrategy.postHydrate}
          id="cxone-init-and-cobrowse-trigger"
        >
          {`
              // Ensure this CXone initialization and event listener setup runs only once
              if (!window.cxoneGlobalSetupStarted) {
                window.cxoneGlobalSetupStarted = true;

                // 1. CXone Loader
                (function(n, u) {
                  window.CXoneDfo = n;
                  window[n] = window[n] || function() {
                    (window[n].q = window[n].q || []).push(arguments);
                  };
                  window[n].u = u;
                  
                  var loaderScriptId = 'cxone-loader-script';
                  if (!document.getElementById(loaderScriptId)) {
                    var e = document.createElement("script");
                    e.id = loaderScriptId;
                    e.type = "module";
                    e.src = u + "?" + Math.round(Date.now() / 1e3 / 3600); // Cache-busting
                    document.head.appendChild(e);
                  } else {
                  }
                })('cxone', 'https://web-modules-de-uk1.niceincontact.com/loader/1/loader.js');

                // 2. Queue CXone Initialization Commands & Setup Cobrowse Listener
                // This function will be executed once the cxone loader pattern is established.
                function setupCxOneInteractions() {
                  try {
                    // Queue CXone initialization commands
                    cxone('init', '1332');
                    cxone('chat', 'init', 1332, 'chat_ca0cfa47-88ac-4cd0-9aa8-4c7f97e3565c');
                    // Allow specific message types, crucial for receiving the #COBRO# message
                    cxone('chat', 'setAllowedExternalMessageTypes', ['MESSAGE_SENT', 'MESSAGE_RECEIVED']);

                    // 3. Add Cobrowse Trigger Event Listener (if not already added)
                    if (!window.cxoneCobrowseMessageListenerAdded) {
                      window.addEventListener("message", function(event) {
                        // Basic validation of the event structure
                        if (event.data && 
                            event.data.actionType === "MESSAGE_RECEIVED" && 
                            event.data.action && 
                            typeof event.data.action.message === 'string') {
                          
                          const messageContent = event.data.action.message;
                          
                          if (messageContent.trim() === "#COBRO#") {
                            
                            if (typeof window.startSurflySession === 'function') {
                              // Call the globally available Surfly session starter function
                              window.startSurflySession(
                                function(pin) { // pinCallback
                                  // TODO: Implement sending PIN back to chat agent if needed and CXone supports it.
                                  // Example: cxone('chat', 'sendMessage', 'Your Surfly Co-browse PIN is: ' + pin);
                                },
                                function() { // sessionEndCallback
                                },
                                function(error) { // errorCallback
                                  console.error("CXone Live Chat via Surfly: Error during Surfly session:", error);
                                }
                              );
                            } else {
                              console.warn("CXone Live Chat: Surfly function 'window.startSurflySession' not found. CoBrowse cannot be initiated. Ensure Surfly script (if used) is loaded and initialized correctly.");
                            }
                          }
                        }
                      });
                      window.cxoneCobrowseMessageListenerAdded = true;
                    }
                  } catch (error) {
                    console.error('CXone Live Chat: Error during setupCxOneInteractions:', error);
                  }
                }

                // The CXone loader pattern queues commands if 'cxone' isn't ready.
                // So, we can call this immediately.
                setupCxOneInteractions();

              } else {
              }
            `}
        </Script>
      )}


      {/* Surfly Script */}
    {LOAD_SURFLY && (
      <>
        <Script
          src="https://surfly.com/surfly.js"
          strategy={ScriptStrategy.postHydrate}
          id="surfly-sdk"
          onLoad={() => {
            // This flag indicates the external Surfly script file itself has loaded.
            // It's used by the initialization logic below.
            if (!window.surflySDKLoaded) {
              // Ensure it's only set once
              console.log(
                'Surfly SDK script file finished loading (onLoad triggered).'
              );
              window.surflySDKLoaded = true;
            }
          }}
          onError={() => {
            // Handle cases where the script itself fails to load (e.g., network error, 404)
            console.error(
              'Surfly SDK script file failed to load (onError triggered).'
            );
            window.surflySDKLoaded = false; // Indicate failure if needed
          }}
        />
        <Script strategy={ScriptStrategy.idle} id="surfly-init-logic">
          {`
            (function() {
              // Ensure this entire initialization block runs only once
              if (window.surflyInitialized) {
                console.log('Surfly initialization process already attempted, skipping.');
                return;
              }
              window.surflyInitialized = true; // Mark that this process has started
              console.log('Surfly: Starting initialization logic.');

              const WIDGET_KEY = "${
                process.env.GATSBY_SURFLY_WIDGET_KEY || ''
              }";
              let currentSurflySession = null;

              function initSurfly() {
                console.log('Surfly: initSurfly() called.');
                if (!WIDGET_KEY) {
                  console.error('Surfly Widget Key (GATSBY_SURFLY_WIDGET_KEY) is not configured. Surfly will not initialize.');
                  return;
                }

                // This check is now more robust in checkAndInit, but a defensive check here is still okay.
                if (typeof window.Surfly === 'undefined' || typeof window.Surfly.init !== 'function') {
                  console.error('Surfly SDK (window.Surfly or window.Surfly.init) not available when initSurfly was called. This should have been caught by checkAndInit.');
                  return;
                }
                
                console.log('Surfly: Attempting to initialize with widget key:', WIDGET_KEY ? '********' : 'NOT SET (Error)');
                const surflySettings = {
                  widget_key: WIDGET_KEY,
                  block_until_agent_joins: false, 
                  hide_until_agent_joins: true,  
                  session_start_confirmation: false,
                  // MODIFICATION 1: Added on_error to surflySettings
                  on_error: function(errorData) {
                      console.error('Surfly SDK reported an error via settings.on_error:', errorData);
                  }
                };

                try {
                  window.Surfly.init(surflySettings, function(init) {
                    if (init.success) {
                      console.log('Surfly: Initialization successful (Surfly.init callback).');
                      if (window.Surfly.isInsideSession) {
                        console.log('Surfly: Already inside a Surfly session upon initialization.');
                        // Potentially sync currentSurflySession if needed
                        // currentSurflySession = window.Surfly.currentSession;
                        return;
                      }

                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) { // Added errorCallback for consistency, though old logic might not use it fully
                        console.log('Surfly: startSurflySession called.');
                        if (currentSurflySession) {
                          console.warn('Surfly: Session is already active or being started.');
                          if (currentSurflySession.pin && typeof pinCallback === 'function') {
                            pinCallback(currentSurflySession.pin);
                          }
                          return;
                        }
                        
                        try {
                          currentSurflySession = window.Surfly.session({}); // Pass session-specific settings here if any

                          currentSurflySession.on("session_created", function(sessionInfo, event) {
                            console.log('Surfly event: session_created. PIN:', sessionInfo.pin);
                            if (typeof pinCallback === 'function') {
                              pinCallback(sessionInfo.pin);
                            }
                          });

                          currentSurflySession.on("session_ended", function(sessionInfo, event) {
                            console.log('Surfly event: session_ended.');
                            currentSurflySession = null;
                            if (typeof sessionEndCallback === 'function') {
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.on("error", function(sessionObj, eventError) { // Parameters might be (session, error) or just (error) depending on event
                            console.error('Surfly event: Session error:', eventError, 'Session obj:', sessionObj);
                            currentSurflySession = null; 
                            // Use the new errorCallback if provided
                            if (typeof errorCallback === 'function') {
                               errorCallback(eventError);
                            } else if (typeof sessionEndCallback === 'function') { 
                              // Fallback to old behavior if no specific error callback
                              sessionEndCallback();
                            }
                          });

                          currentSurflySession.startLeader();
                          console.log('Surfly: Leader session started.');
                        } catch (sessionError) {
                          console.error('Surfly: Error creating or starting Surfly session:', sessionError);
                          currentSurflySession = null;
                          if (typeof errorCallback === 'function') {
                            errorCallback(sessionError);
                          } else if (typeof sessionEndCallback === 'function') {
                            sessionEndCallback();
                          }
                        }
                      };

                      window.endSurflySession = function() {
                        console.log('Surfly: endSurflySession called.');
                        if (currentSurflySession) {
                          try {
                            currentSurflySession.end();
                            console.log('Surfly: Session end command issued.');
                            // currentSurflySession will be nulled by 'session_ended' event
                          } catch (endError) {
                            console.error('Surfly: Error calling currentSurflySession.end():', endError);
                            currentSurflySession = null; // Ensure cleanup
                          }
                        } else {
                          console.log('Surfly: No active session to end.');
                        }
                      };
                      console.log('Surfly: window.startSurflySession and window.endSurflySession are now defined.');

                    } else {
                      console.error('Surfly: Initialization failed (Surfly.init callback). Error:', init.error || 'Unknown error', 'Full init object:', init);
                    }
                  });
                  
                  // Fallback timeout in case the Surfly.init callback never fires or startSurflySession isn't defined
                  setTimeout(function() {
                    if (typeof window.startSurflySession === 'undefined') {
                      console.warn('Surfly: Init callback may not have fired or defined startSurflySession within 3 seconds. Defining fallback/stub functions.');
                      
                      window.startSurflySession = function(pinCallback, sessionEndCallback, errorCallback) {
                        console.error('Surfly: Fallback startSurflySession - Surfly initialization likely failed or timed out, session cannot be started.');
                        if (typeof errorCallback === 'function') {
                           errorCallback(new Error('Surfly init fallback timeout'));
                        } else if (typeof sessionEndCallback === 'function') {
                          sessionEndCallback();
                        }
                      };

                      window.endSurflySession = function() {
                         console.error('Surfly: Fallback endSurflySession - Surfly not properly initialized.');
                      };
                    }
                  }, 3000); // 3 seconds
                  
                } catch (initError) {
                  console.error('Surfly: Critical error during window.Surfly.init() call:', initError);
                }
              }
              
              // Polling function to wait for Surfly SDK to be available
              let attempts = 0;
              const maxAttempts = 10; // Try for 5 seconds (10 attempts * 500ms interval)
              const interval = 500;   // ms

              function checkAndInit() {
                attempts++;
                // MODIFICATION 2: Enhanced the condition to check for Surfly.init function
                if (window.surflySDKLoaded && typeof window.Surfly !== 'undefined' && typeof window.Surfly.init === 'function') {
                  console.log('Surfly: SDK loaded and Surfly.init is available. Proceeding to initSurfly(). Attempt:', attempts);
                  initSurfly();
                } else if (attempts < maxAttempts) {
                  // console.log(\`Surfly: SDK not yet fully ready. Attempt \${attempts}/\${maxAttempts}. Retrying in \${interval}ms. SDKLoaded: \${!!window.surflySDKLoaded}, SurflyObject: \${typeof window.Surfly}, SurflyInit: \${typeof window.Surfly === 'object' && window.Surfly ? typeof window.Surfly.init : 'N/A'}\`);
                  setTimeout(checkAndInit, interval);
                } else {
                  console.error(\`Surfly: Timeout. SDK did not load or Surfly.init not available after \${(maxAttempts * interval / 1000)} seconds (\${attempts} attempts). Surfly will not be initialized. SDKLoaded: \${!!window.surflySDKLoaded}, SurflyObject: \${typeof window.Surfly}, SurflyInit: \${typeof window.Surfly === 'object' && window.Surfly ? typeof window.Surfly.init : 'N/A'}\`);
                  // Define stubs if timeout occurs before init, to prevent errors if called
                  if (typeof window.startSurflySession === 'undefined') {
                     window.startSurflySession = function(pinCb, endCb, errCb) { console.error('Surfly: startSurflySession (stub) - SDK did not initialize.'); if(typeof errCb === 'function') errCb(new Error('Surfly SDK init timeout')); else if(typeof endCb === 'function') endCb();};
                     window.endSurflySession = function() { console.error('Surfly: endSurflySession (stub) - SDK did not initialize.'); };
                  }
                }
              }
              
              // Start the check. It relies on window.surflySDKLoaded being set by the <Script onLoad>
              checkAndInit();

            })();
          `}
        </Script>
      </>
    )}
    </>
  );
};


      
   